import React from 'react';
import { Plus } from 'styled-icons/boxicons-regular';

import { BaseBox, Button } from 'src/kit';

export const AddButton = ({ children, ...rest }) => {
  return (
    <Button mt={20} colors="primary" fontWeight="light" {...rest}>
      <BaseBox as={Plus} ml="-3px" mr={5} size={20} />
      <span>{children}</span>
    </Button>
  );
};
